import Vue from 'vue'
import Vuex, { Store } from 'vuex'

import common from './modules/common'
import cart from './modules/cart'
import myOrderHistoryDetailV2 from './modules/myOrderHistoryDetailV2'
import myOrderHistoryV2 from './modules/myOrderHistoryV2'
import preOrder from './modules/preOrder'
import user from './modules/user'

import modal from './modules/modal'
import toast from './modules/toast'

import myOrderHistory from './legacy/myOrderHistory'
import legacy from './legacy/legacy'

Vue.use(Vuex)

const store = new Store({
  modules: {
    common,
    cart,
    myOrderHistoryDetailV2,
    myOrderHistoryV2,
    preOrder,
    user,

    modal,
    toast,

    myOrderHistory,
    legacy
  }
})

// Vue.use({
//   install(Vue, opt) {
//     Vue.prototype.$storeDispatch = async (type, payload, options = { hideErrorMessage: false, message: null }) => {
//       // ResultSet 인터페이스에 맞춰서 반환되어야 함. 더 번거로워지나?
//       const resultSet = await store.dispatch(type, payload)
//
//       if (resultSet.failed && !options.hideErrorMessage) {
//         store.dispatch('modal/open', {
//           type: 'Check',
//           message: options.message || resultSet.message,
//           onOK: async () => {
//             // TODO 호출부에 제어권 넘겨주어야 함. ex. 모달 닫힌후 액션
//             store.dispatch('modal/close')
//           }
//         })
//       }
//
//       return resultSet
//     }
//   }
// })

export default store
